import React from 'react';
import _ from 'lodash';
import slugify from 'slugify';
import { Link, withPrefix } from 'gatsby';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';

import { TableData, TableRow } from '~components/common/Table';
import { HTMLContent } from '~components/Content';
import { rowRendererProps } from '../propTypes';
import { RowDataRenderer } from './default';

export default function VBMRulesRowRenderer({ state }) {
  const stateName = state.fieldValue;
  const stateSlug = slugify(stateName.toLowerCase());
  const stateData = _.keyBy(state.nodes, 'field_type');

  // using this format to populate data to avoid errors when compiling locally
  const vbmLaws = stateData.absentee_voting_laws
    ? stateData.absentee_voting_laws.html
    : 'N/A';
  const IdVbmRequest = stateData.id_laws_absentee_request
    ? stateData.id_laws_absentee_request.html
    : 'N/A';
  const IdVbmReturn = stateData.id_laws_ballot_return
    ? stateData.id_laws_ballot_return.html
    : 'N/A';

  let summaryText;
  const stateMailingBallots = stateData.has_automatic_vbm.bool_value;
  const stateNoExcuse = stateData.has_no_excuse_absentee.bool_value;

  if (stateMailingBallots) {
    summaryText = 'Ballots are automatically sent to all registered voters';
  } else if (stateNoExcuse) {
    summaryText = 'No excuse required';
  } else {
    summaryText = 'Excuse required';
  }

  configureAnchors({ offset: -75, scrollDuration: 300 });

  return (
    <TableRow>
      <TableData>
        <ScrollableAnchor id={stateSlug}>
          <a
            href={`/how-to-vote/${stateSlug}/`}
            title={`How to vote in ${stateName}`}
          >
            {stateName}
          </a>
        </ScrollableAnchor>
      </TableData>
      <RowDataRenderer
        columns={[
          {
            title: 'Absentee ballot rules',
            valueNode: (
              <div>
                <div className='mb-3 font-bold'>
                  <HTMLContent content={summaryText} />
                </div>
                <HTMLContent content={vbmLaws} />
              </div>
            ),
          },
          {
            title: 'ID requirements',
            valueNode: (
              <div>
                <b> Ballot request</b>
                <br /> <HTMLContent content={IdVbmRequest} />
                <b>Ballot return</b>
                <br /> <HTMLContent content={IdVbmReturn} />
              </div>
            ),
          },

          {
            title: 'Request your ballot',
            valueNode: (
              <Link
                to={withPrefix(`/absentee-mail-ballot/${stateSlug}/`)}
                title={`Request your ${stateName} absentee or mail ballot`}
              >
                Request your {stateName} absentee or mail ballot
              </Link>
            ),
          },
        ]}
      />
    </TableRow>
  );
}

VBMRulesRowRenderer.propTypes = rowRendererProps;
